<svg width="20" height="20" fill="none" version="1.1" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
 <path d="m5.8335 8.3333 4.1667 3.3334 4.1666-3.3334" stroke="#16151C" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
</svg>
